/* eslint-disable */
export default {
  unknown: '未知',
  multipleMatches: '多個相符項目',
  anonymous: '匿名',
  none: '無',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
